import { render, staticRenderFns } from "./EditSectionsModal.vue?vue&type=template&id=605c936c&scoped=true"
import script from "./EditSectionsModal.vue?vue&type=script&lang=js"
export * from "./EditSectionsModal.vue?vue&type=script&lang=js"
import style0 from "./EditSectionsModal.vue?vue&type=style&index=0&id=605c936c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605c936c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('605c936c')) {
      api.createRecord('605c936c', component.options)
    } else {
      api.reload('605c936c', component.options)
    }
    module.hot.accept("./EditSectionsModal.vue?vue&type=template&id=605c936c&scoped=true", function () {
      api.rerender('605c936c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/plantNursery/sectors/components/modal/EditSectionsModal.vue"
export default component.exports